<template>
  <div
    class="row documents"
    v-if="showableDocuments.length > 0"
  >
    <div class="col-md-12">
      <hint
        value="Прикрепите сканы документов в соответствующие для них разделы.<br>Максимально допустимый размер файла - 2 МБ."
        style="right: 15px"
      />
      <div v-if="visitor.docError" class="form-fielderror" style="right: 40px">
        <label>!</label>
        <div class="form-fielderror-text">
          <div>Загрузите документы</div>
        </div>
      </div>
      <h4>Документы</h4>
      <div class="documents-flex-row row">
        <label class="flex-label residence-checkbox col-md-4"
               v-if="residenceCheckBoxCondition">
          <input v-model="visitorResidence"
                 type="checkbox"
                 :id="`${visitor.uuid}-visitor-residence`"
          />
          <div class="control-label">{{ 'Имеется вид на жительство' }}</div>
        </label>
      </div>
    </div>

    <div class="col-md-12 panel-group documents-form-flex" :id="'documents' + visitorIndex">
      <template v-for="(documentObj, documentKey) in showableDocuments">
        <div :id="`visitor-document-block-${documentObj.document.short_name}`" :key="documentKey">
          <uppy-uploader
            v-model="visitor.files[documentObj.document.short_name]"
            :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
            :document-comment="documentObj.comment"
            :document-key="getDocumentKey(documentObj)"
            :document-name="documentObj.document.name"
            :document-need-expire="documentObj.need_expire"
            :document-id="documentObj.document.id"
            :document-short-name="documentObj.document.short_name"
            :max-files-count="documentObj.document.max_file"
            entity-type="personal"
            :entity-id="visitor.personal.id"
            :documents-show-condition="isView"
            :get-uuid="getUUID"
            :has-errors="blockHasErrors(documentObj.document.short_name)"
            :key="`${visitor.uuid}-${documentObj.document.short_name}`"
            :form="form"
            :owner-type="ownerType"
            :mime-types="$store.getters.documentValidators.find(validator => validator.id === documentObj.document.validator).mimeTypes"
            ref="uploader"
            @fileRemoved="fileRemoved"
            @change="forceUpdateForUppyUploader"
          />
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import DocumentTypes from '@/common/enums/DocumentTypes'
import UppyUploader from '@/common/components/inputs/UppyUploader'
import visitorInputMixin from '@/common/mixins/application-form/visitorInputMixin'
import visitorsSectionMixin from '@/common/mixins/application-form/visitorsSectionMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorDocumentsFormBlock',

  components: { Hint, UppyUploader },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    nationalityDocuments: {
      type: Array,
      default: () => []
    },

    personalNationalities: {
      type: [Array, Object],
      default: () => []
    },

    transportIndex: {
      type: Number,
      default: null
    }
  },

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
    })
  },

  methods: {
    blockHasErrors (field) {
      if (this.isPassKindTransport) {
        return this.hasError(this.errors?.visitors?.[0]?.transports?.[this.transportIndex]?.drivers?.[this.visitorIndex]?.files, field)
      } else {
        return this.hasError(this.errors?.visitors?.[this.visitorIndex]?.files, field)
      }
    },

    blockErrors(field) {
      return this.hasError(this.errors?.visitors?.[this.visitorIndex]?.files, field)?.[0]
    },

    getDocumentKey(document) {
      let documentKey = 'visitor' + this.visitorIndex + document.document.short_name
      if (this.transportIndex !== null) {
        documentKey = 'visitor' + 'transport' + this.transportIndex + 'driver' + this.visitorIndex + document.document.short_name
      }

      return documentKey
    },

    /**
     * @param {UppyFile<UppyFileMeta, Null>} removedFile
     */
    fileRemoved(removedFile) {
      ApiClient.removeUploadedDocument({ uuid: removedFile.meta.uuid })
    },

    // TODO Analyze why the component does not register document changes in the UppyUploader without the “$forceUpdate” method and why it registers with the “$forceUpdate” method
    // TODO Remove the crutch based on the results of the analysis above
    forceUpdateForUppyUploader() {
      this.$forceUpdate()
    },

    getUUID(file) {
      return file.uuid
    }
  },

  computed: {
    visitorResidence: {
      get() {
        return this.visitor.personal.residence
      },

      set(value) {
        this.visitor.personal.residence = value
      }
    },

    ownerType() {
      return DocumentTypes.PERSONAL
    },

    residenceCheckBoxCondition() {
      const personal = this.visitor.personal
      const nationality = this.personalNationalities.find(currentValue => currentValue.iso2 === 'RU')

      return personal.nationality_id !== 0 && personal.nationality_id !== nationality.id;
    },

    showableDocuments() {
      const personal = this.visitor.personal
      const nationality = personal?.nationality_id
      const identification_id = personal?.identification_id
      const residence = personal?.residence
      const application = this.form.application
      const applicationGroupPurposeId = application.application_group_purpose_id
      const terminalRegionId = application.terminal_region_id

      if (!nationality || !identification_id) {
        return []
      }

      const docs = []
      for (const document of this.nationalityDocuments) {
        if (![null, applicationGroupPurposeId].includes(document.application_group_purpose_id)) {
          continue
        }
        if (![null, nationality].includes(document.nationality_id)) {
          continue
        }
        if (![null, identification_id].includes(document.nationality_identification_id)) {
          continue
        }
        if (![null, terminalRegionId].includes(document.region_id)) {
          continue
        }
        if (document.residence_visible === 0 && Boolean(residence) === true) {
          continue
        }
        if (document.residence_visible === 1 && Boolean(residence) === false) {
          continue
        }

        docs.push(document)
      }

      return docs
    }
  }
}
</script>
